import clickOutside from './clickOutside'
import currency from './currency'
import focus from './focus'

export default function (Vue) {
  Vue.directive('click-outside', clickOutside)
  Vue.directive('currency', currency)
  Vue.directive('focus', focus)
}
